/**
 * La Tienda Egypt — Racket Customizer
 * Handles: name input, color picker, flag dropdown,
 * dynamic pricing (75 EGP/char + 200 EGP/flag, Palestine 150 EGP),
 * and contact form submission with summary.
 */

(function() {
  'use strict';

  var section = document.querySelector('[data-racket-customizer]');
  if (!section) return;

  var tool = section.querySelector('.rc-tool');
  if (!tool) return;

  var CHAR_PRICE = parseInt(tool.dataset.charPrice, 10) || 75;
  var FLAG_PRICE = parseInt(tool.dataset.flagPrice, 10) || 200;
  var PALESTINE_PRICE = parseInt(tool.dataset.palestinePrice, 10) || 150;

  /* ===== DOM Elements ===== */
  var nicknameInput = section.querySelector('[data-nickname-input]');
  var colorSwatches = section.querySelectorAll('[data-color-swatch]');
  var flagSelect = section.querySelector('[data-flag-select]');
  var otherCountryWrap = section.querySelector('[data-other-country-wrap]');
  var otherCountryInput = section.querySelector('[data-other-country-input]');
  var summaryInput = section.querySelector('[data-summary-input]');

  var priceBreakdown = section.querySelector('[data-price-breakdown]');
  var namePriceLine = section.querySelector('[data-name-price-line]');
  var flagPriceLine = section.querySelector('[data-flag-price-line]');
  var charCountEl = section.querySelector('[data-char-count]');
  var nameTotalEl = section.querySelector('[data-name-total]');
  var flagTotalEl = section.querySelector('[data-flag-total]');
  var flagLineLabel = section.querySelector('[data-flag-line-label]');
  var totalPriceEl = section.querySelector('[data-total-price]');
  var priceEmpty = section.querySelector('[data-price-empty]');
  var submitBtn = section.querySelector('[data-customizer-submit]');

  var deliverySelector = section.querySelector('[data-delivery-selector]');
  var deliveryInput = section.querySelector('[data-rc-delivery-input]');

  /* ===== State ===== */
  var state = {
    nickname: '',
    textColor: 'Green',
    flag: '',
    otherCountry: ''
  };

  /* ===== Helpers ===== */
  function flagPriceFor(flag) {
    if (!flag) return 0;
    return flag === 'Palestine' ? PALESTINE_PRICE : FLAG_PRICE;
  }

  /* ===== Price Calculation ===== */
  function updatePrice() {
    var nameChars = state.nickname.length;
    var nameTotal = nameChars * CHAR_PRICE;
    var hasFlag = !!(state.flag && state.flag !== '');
    var flagTotal = flagPriceFor(state.flag);
    var total = nameTotal + flagTotal;

    if (nameChars > 0) {
      namePriceLine.hidden = false;
      charCountEl.textContent = nameChars;
      nameTotalEl.textContent = nameTotal.toLocaleString('en-US');
    } else {
      namePriceLine.hidden = true;
    }

    flagPriceLine.hidden = !hasFlag;
    if (hasFlag) {
      if (flagLineLabel) {
        flagLineLabel.textContent = state.flag === 'Palestine'
          ? 'Flag — Palestine (offer)'
          : 'Flag';
      }
      if (flagTotalEl) flagTotalEl.textContent = flagTotal.toLocaleString('en-US');
    }

    if (total > 0) {
      priceBreakdown.hidden = false;
      priceEmpty.hidden = true;
      totalPriceEl.textContent = 'EGP ' + total.toLocaleString('en-US');
      submitBtn.disabled = false;
    } else {
      priceBreakdown.hidden = true;
      priceEmpty.hidden = false;
      totalPriceEl.textContent = 'EGP 0';
      submitBtn.disabled = true;
    }

    updateSummary(total);
  }

  function updateSummary(total) {
    if (!summaryInput) return;
    var lines = [];

    if (state.nickname) {
      lines.push('Name: ' + state.nickname + ' (' + state.nickname.length + ' chars x EGP ' + CHAR_PRICE + ' = EGP ' + (state.nickname.length * CHAR_PRICE) + ')');
      lines.push('Text Color: ' + state.textColor);
    }

    var flag = state.flag;
    if (flag) {
      var thisFlagPrice = flagPriceFor(flag);
      var flagNote = flag === 'Palestine' ? ' (offer, save EGP ' + (FLAG_PRICE - PALESTINE_PRICE) + ')' : '';
      lines.push('Flag: ' + flag + ' (EGP ' + thisFlagPrice + ')' + flagNote);
    }

    var deliveryVal = deliveryInput ? deliveryInput.value : '';
    if (deliveryVal === 'send_racket') {
      lines.push('Delivery: Send racket for direct application');
    } else if (deliveryVal === 'receive_sticker') {
      lines.push('Delivery: Receive sticker to apply yourself');
    }

    if (total > 0) {
      lines.push('Total: EGP ' + total);
    }

    summaryInput.value = lines.join(' | ');
  }

  /* ===== Event Listeners ===== */

  if (nicknameInput) {
    nicknameInput.addEventListener('input', function() {
      state.nickname = this.value.trim();
      updatePrice();
    });
  }

  if (colorSwatches.length) {
    colorSwatches.forEach(function(radio) {
      radio.addEventListener('change', function() {
        if (this.checked) {
          state.textColor = this.value;
          updatePrice();
        }
      });
    });
  }

  if (flagSelect) {
    flagSelect.addEventListener('change', function() {
      var val = this.value;
      if (val === 'other') {
        otherCountryWrap.hidden = false;
        state.flag = '';
        if (otherCountryInput) otherCountryInput.focus();
      } else {
        otherCountryWrap.hidden = true;
        state.flag = val;
        state.otherCountry = '';
        if (otherCountryInput) otherCountryInput.value = '';
      }
      updatePrice();
    });
  }

  if (otherCountryInput) {
    otherCountryInput.addEventListener('input', function() {
      state.otherCountry = this.value.trim();
      state.flag = state.otherCountry;
      updatePrice();
    });
  }

  /* Delivery method toggle */
  if (deliverySelector && deliveryInput) {
    var deliveryCards = deliverySelector.querySelectorAll('[data-delivery-value]');
    deliveryCards.forEach(function(card) {
      card.addEventListener('click', function() {
        deliveryCards.forEach(function(c) { c.classList.remove('is-active'); });
        card.classList.add('is-active');
        deliveryInput.value = card.getAttribute('data-delivery-value');
        updatePrice();
      });
    });
  }

  /* Initialize */
  updatePrice();

  /* Conversion tracking — fire GA4 on submit; snapshot PII for the post-redirect Meta Lead fire */
  var form = section.querySelector('form');
  if (form) {
    form.addEventListener('submit', function () {
      var nameChars = state.nickname ? state.nickname.length : 0;
      var upcharge = (nameChars * CHAR_PRICE) + flagPriceFor(state.flag);
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'generate_lead', {
          form_type: 'racket_customization',
          currency: 'EGP',
          value: upcharge
        });
      }
      try {
        var nameEl = form.querySelector('[name="contact[name]"]');
        var emailEl = form.querySelector('[name="contact[email]"]');
        var phoneEl = form.querySelector('[name="contact[phone]"]');
        sessionStorage.setItem('latienda_lead_pending_racket_customization', JSON.stringify({
          name: nameEl ? nameEl.value : '',
          email: emailEl ? emailEl.value : '',
          phone: phoneEl ? phoneEl.value : '',
          value: upcharge
        }));
      } catch (e) { /* sessionStorage unavailable — Lead will fire without user_data */ }
    }, { once: true });
  }

})();
